export const firebaseWebConfig = {
  apiKey: "AIzaSyDFg91Mnp8v-OYYpB5vWrx-qy3bX2SQVv8",
  authDomain: "tuboletaya.firebaseapp.com",
  databaseURL: "https://tuboletaya-default-rtdb.firebaseio.com",
  projectId: "tuboletaya",
  storageBucket: "tuboletaya.appspot.com",
  messagingSenderId: "220765375792",
  appId: "1:220765375792:web:a3523bfb261ebdff11ccf5",
};

const functionsRegion = "us-central1";
const functionsProjectId = "tuboletaya";

export const cloudFunctionsBaseUrl =
  process.env.REACT_APP_CF_BASE_URL ||
  `https://${functionsRegion}-${functionsProjectId}.cloudfunctions.net`;

export const buildCloudFunctionUrl = (functionName) =>
  `${cloudFunctionsBaseUrl}/${functionName}`;
